import { useTranslate } from 'ra-core';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

function NotFound() {
  const t = useTranslate();
  return (
    <div className="min-h-full flex flex-col justify-center text-center items-center gap-3">
      <h1>Not Found</h1>
      <h2 className="font-extrabold px-4">404</h2>
      <div className="max-w-md">
        <h4 className="font-bold mb-1">{t('error.404.header')}</h4>
        <h6 className="mb-3">{t('error.404.message')}</h6>
        <Button variant="outline" asChild>
          <Link to="/">{t('error.full_screen.button')}</Link>
        </Button>
      </div>
    </div>
  );
}

export default NotFound;
